import { render, staticRenderFns } from "./FormFlat.vue?vue&type=template&id=7f3f2f67&"
import script from "./FormFlat.vue?vue&type=script&lang=js&"
export * from "./FormFlat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports